export const subcategory = {
  subCategory: 'Sous catégorie',
};
